import { initialFieldsState } from 'reducers/adCreation';

export const VALIDATE_FIELDS = 'VALIDATE_FIELDS';
export const VALIDATE_STEP_FIELDS = 'VALIDATE_STEP_FIELDS';
export const VALIDATE_FLAGGED_FIELDS_REQUESTED = 'VALIDATE_FLAGGED_FIELDS_REQUESTED';

export function validateFields({ fields, groups = {}, initialValidation = false }) {
  return {
    type: VALIDATE_FIELDS,
    fields,
    groups,
    initialValidation,
  };
}

export function validateStepFields({ step, fields, groups = {} }) {
  return {
    type: VALIDATE_STEP_FIELDS,
    step,
    fields,
    groups,
  };
}

export function resetValidation({ groups }) {
  return {
    type: VALIDATE_FIELDS,
    fields: initialFieldsState,
    groups,
    initialValidation: true,
  };
}



// WEBPACK FOOTER //
// ./src/actions/validation.js